// extracted by mini-css-extract-plugin
module.exports = {"messageContainer":"styles_messageContainer__1yg4h","icon":"styles_icon__1lvRI","queryContainer":"styles_queryContainer__2ErBA"};